module.exports = __webpack_public_path__ + "img/project6_5.png.4bb4a458.webp";